/**
 * @file Purchase album folder landing page.
 */

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import qs from 'query-string';
import url from 'url';
import get from 'lodash.get';

import OnboardingLandingGeneric from '../../onboarding/start/OnboardingLandingGeneric';
import Spinner from '../../global/Spinner';
import { ALBUM_SUBTYPE } from '../../../constants/albums';
import OnboardingLandingSchools from '../../onboarding/start/OnboardingLandingSchools';
import { getAccountCheckoutGreetingName } from '../../../util/account';
import OnboardingLandingSchoolsHeadMeta from '../../onboarding/start/OnboardingLandingSchoolsHeadMeta';
import OnboardingBrandedHeader from '../../onboarding/start/OnboardingBrandedHeader';
import { isPpd } from '../../../util/album';

class PurchaseAlbumStart extends Component {
  static propTypes = {
    album: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      creator: PropTypes.shape({
        name: PropTypes.string,
        logo_image: PropTypes.shape({
          url: PropTypes.string,
        }),
      }),
    }),
    authenticated: PropTypes.bool,
    history: PropTypes.shape({
      push: PropTypes.func.isRequired,
    }),
    location: PropTypes.shape({
      search: PropTypes.string,
    }),
    loading: PropTypes.bool,
  };

  onGetStarted = () => {
    const { album, authenticated, history, location } = this.props;
    const targetUrl = url.format({
      pathname: `/purchase/album/${album.id}`,
      search: location.search,
    });

    if (authenticated) {
      history.push(targetUrl);
    } else {
      history.push({
        pathname: '/auth/phone',
        search: `?${qs.stringify({ next: targetUrl })}`,
      });
    }
  };

  render() {
    const { album, loading } = this.props;

    if (loading || !album) {
      return (
        <div className="text-center mt-5">
          <Spinner />
        </div>
      );
    }

    const renderLandingPageContent = () => {
      if (album.album_subtype === ALBUM_SUBTYPE.SCHOOLS) {
        return (
          <Fragment>
            <OnboardingLandingSchoolsHeadMeta />
            <OnboardingLandingSchools
              displayName={getAccountCheckoutGreetingName(album.creator)}
              freeJoin={isPpd(album)}
              onGetStarted={this.onGetStarted}
            />
          </Fragment>
        );
      }

      return (
        <OnboardingLandingGeneric
          stringContext={album}
          onGetStarted={this.onGetStarted}
        />
      );
    };

    return (
      <div className="wrapper-main content-wrap-gray">
        <OnboardingBrandedHeader
          title={get(album, 'name')}
          logo={get(album, 'creator.logo_image')}
        />
        {renderLandingPageContent()}
      </div>
    );
  }
}

export default PurchaseAlbumStart;
